import type { TaxReportingTypeEnum } from "~/graphql/supergraphTypes";

export const TAX_REPORTING_TYPE_BY_CONTROLLING_PERSON_FIELD: Partial<
  Record<string, TaxReportingTypeEnum>
> = {
  fatcaSubstantialOwners: "fatca_substantial_owner",
  crsControllingPersons: "crs_controlling_person",
};
